export default "__VITE_ASSET__DrTp0rdY__"